import Card from "components/Card/Card.jsx";
import Select from "react-select";
import Collapsible from "react-collapsible";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import { style } from "../../../variables/Variables";
import React, { Component } from "react";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";
import { extendMoment } from "moment-range";
import originalMoment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Modal,
  ControlLabel,
  Table,
  Pagination,
} from "react-bootstrap";
import "api/purchaseOrder/PurchaseOrder";
import LoadingSpinner from "views/Components/loadingSpinner";
import ScreenLoader from "views/Components/screenLoader";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Radio from "components/CustomRadio/CustomRadio.jsx";
const moment = extendMoment(originalMoment);

class logs extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {}


  render() {
    const errormessages = this.state.errormessages;
   
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <Card
            content={
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginBottom: "40px" }}
                >
                  <Row>
                    <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                      
                    </Col>
                  </Row>
                </Col>
              </Row>
            }
          />
        </Grid>
      </div>
    );
  }
}
export default logs;
